import {CardEnum, type CardStateUnordered} from '@colonist/game-states'

export const CARD_STACK_SIZES_1: CardStateUnordered = Object.keys(CardEnum).reduce<CardStateUnordered>((acc, cardEnumKeyOrValue) => {
    const cardEnum = Number(cardEnumKeyOrValue) as CardEnum
    if(isNaN(cardEnum)) return acc

    acc[cardEnum] = 1
    return acc
}, {})
